/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/
function init() {
  setupCompleteTheLookCarousel();
  handleVendorCollectionDefaultSorting();
}

function setupCompleteTheLookCarousel() {
  const completeTheLookSwiper = document.querySelector('[js-complete-the-look="swiper"]');

  if (!completeTheLookSwiper) {
    return;
  }

  var swiper = new Swiper(completeTheLookSwiper, {
    slidesPerView: 3,
    spaceBetween: 6,
    navigation: {
      prevEl: ".swiper-button-prev",
      nextEl: ".swiper-button-next",
    },
  });
}

function handleVendorCollectionDefaultSorting() {
  const pathname = window.location.pathname;

  if (!pathname.includes('/collections/vendors')) {
    return;
  }

  let url = new URL(window.location.href);

  if (url.searchParams.has('sort_by')) {
    return;
  }

  url.searchParams.set('sort_by', 'created-descending');
  window.location.href = url.toString();
}

document.addEventListener('DOMContentLoaded',function(event){
  init();
});
